/** @jsxImportSource @emotion/react */

import type { ElementType } from "react";
import { Clay } from "../..";
import { cardBodyCSS } from "./CardBody.css";
import type { CardBodyProps } from "./CardBody.types";

export const CardBody = <Element extends ElementType>({
  sx,
  children,
  ...restProps
}: CardBodyProps<Element>) => {
  return (
    <Clay css={[cardBodyCSS, sx]} {...restProps}>
      {children}
    </Clay>
  );
};
